/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { convertChannelCasing } from 'lib-shared-api-utils';
import { transformConversation, transformConversationStringifiedProperties, transformMainConversation, transformRequesterConversation, } from 'utils/conversation/transformConversation';
/**
 * Transforms the conversation endpoint response.
 *
 * @param response The response from the endpoint.
 */
export function transformReadConversationResponse(response) {
    transformMainConversation(response.data.history.main_conversation);
    response.data.requester_conversations.forEach(({ conversation }) => transformRequesterConversation(conversation));
    response.data.history.linked_conversations.forEach(({ conversation }) => transformConversation(conversation));
    if (response.data.history.linked_to) {
        transformConversation(response.data.history.linked_to.conversation);
    }
    return response;
}
/**
 * Transforms the conversations endpoint response.
 *
 * @param response The response from the endpoint.
 */
export function transformReadConversationsResponse(response) {
    response.data.conversations.forEach(({ conversation }) => transformConversation(conversation));
    return response;
}
/**
 * Transforms the conversation messages endpoint response.
 *
 * @param response The response from the endpoint.
 */
export function transformReadConversationMessagesResponse(response) {
    response.data.messages.forEach((message) => {
        message.channel = convertChannelCasing(message.channel, 'snake');
        transformConversationStringifiedProperties(message.attributes);
    });
    return response;
}
/**
 * Transforms the scheduled conversation batches endpoint response.
 *
 * @param response The response from the endpoint.
 */
export function transformReadScheduledConversationBatchesResponse(response) {
    // The response seems to be ordered "oldest first", which isn't great for the UI, so I'm reversing
    // it in order to show the most recent scheduled batches first.
    response.data.batches.reverse();
    return response;
}
/**
 * Transforms the conversation message delivery events endpoint response.
 *
 * @param response The response from the endpoint.
 */
export function transformReadConversationMessageDeliveryEvents(response) {
    return {
        data: {
            delivery_events: response,
        },
        meta: {},
    };
}
